import { useEffect } from "react";
import { Outlet, useNavigate, useLocation, NavLink } from "react-router-dom";
import {
  ArrowLeft, HouseLine, TicketIcon, CreditCard,
  IdentificationBadge, UserCircle,
} from "@phosphor-icons/react";
import "@/majhe.css";

const NAV = [
  { to: "/majhe", icon: HouseLine, label: "Home", end: true, tid: "majhe-nav-home" },
  { to: "/majhe/book/quick", icon: TicketIcon, label: "Book", tid: "majhe-nav-book" },
  { to: "/majhe/card", icon: CreditCard, label: "Card", tid: "majhe-nav-card" },
  { to: "/majhe/pass", icon: IdentificationBadge, label: "Pass", tid: "majhe-nav-pass" },
  { to: "/majhe/profile", icon: UserCircle, label: "Profile", tid: "majhe-nav-profile" },
];

export function MajheHeader({ title, onBack, right, transparent }) {
  const navigate = useNavigate();
  return (
    <div className="majhe-header" style={transparent ? { background: "transparent", borderBottom: "none" } : {}}>
      <button data-testid="majhe-back" className="majhe-header__back"
        type="button"
        aria-label={`Go back from ${title || "page"}`}
        onClick={() => (onBack ? onBack() : navigate(-1))}>
        <ArrowLeft size={20} weight="bold" aria-hidden="true"/>
      </button>
      <h1 className="majhe-header__title flex-1">{title}</h1>
      {right}
    </div>
  );
}

export function MajheBrand({ size = "md" }) {
  return (
    <span className="majhe-brand" aria-label="MajheApp by KTCL Goa">
      <span className="majhe-brand__logo" style={size === "lg" ? { fontSize: 16, padding: "6px 16px" } : { fontSize: 13 }}>
        MajheApp
      </span>
      <span className="majhe-brand__x" aria-hidden="true">×</span>
      <span className="majhe-brand__partner" style={{ fontSize: size === "lg" ? 15 : 13 }}>
        KTCL Goa
      </span>
    </span>
  );
}

export default function MajheLayout({ hideNav }) {
  const loc = useLocation();
  const isLoginRoute = loc.pathname === "/majhe/login";
  const hideTabs = hideNav || isLoginRoute;

  // Hide the "Made with Emergent" platform badge inside the MajheApp so it never
  // overlaps the bottom nav, sticky buttons, or page content on real mobile devices.
  useEffect(() => {
    document.body.classList.add("majhe-mode");
    return () => document.body.classList.remove("majhe-mode");
  }, []);

  return (
    <div className="majhe-app">
      <a href="#majhe-main-content" className="majhe-skip-link">Skip to main content</a>
      <div id="majhe-main-content" tabIndex={-1} role="main" className={`majhe-page ${hideTabs ? "no-nav" : ""}`}>
        <Outlet />
      </div>
      {!hideTabs && <MajheNav/>}
    </div>
  );
}

function MajheNav() {
  return (
    <nav data-testid="majhe-bottom-nav" className="majhe-nav" aria-label="Main navigation">
      <div className="majhe-nav__row" role="tablist">
        {NAV.map((n) => (
          <NavLink key={n.label} to={n.to} end={n.end} data-testid={n.tid}
            role="tab"
            aria-label={`${n.label} tab`}
            className={({ isActive }) => `majhe-nav__item ${isActive ? "active" : ""}`}>
            {({ isActive }) => (
              <>
                <div className="majhe-nav__icon" aria-hidden="true">
                  <n.icon size={22} weight={isActive ? "fill" : "regular"}/>
                </div>
                <span>{n.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
